import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import red from "@mui/material/colors/red";
import green from "@mui/material/colors/green";
import { v4 as uuidv4 } from 'uuid';

import "./styles.scss";

const dot = new RegExp(/[.]/);
const smallLetter = new RegExp(/[a-z]/);
const capitalLetter = new RegExp(/[A-Z]/);
const number = new RegExp(/\d/);
const specialChar = new RegExp(/[*/@!#%&()$`',?";:-=+_|><^~{}\]]/);

const PasswordCritera = ({ value }: any) => {
  const [minLength, setMinLength] = useState(false);
  const [hasUpper, setHasUpper] = useState(false);
  const [hasLower, setHasLower] = useState(false);
  const [hasSpecial, setHasSpecial] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasDot, setHasDot] = useState(true);

  const stateArray = [
    {
      id: minLength,
      error: "at least 8 characters",
    },
    {
      id: hasUpper,
      error: "1 upper case letter",
    },
    {
      id: hasLower,
      error: "1 lower case letter",
    },
    {
      id: hasSpecial,
      error: " 1 special character",
    },
    {
      id: hasNumber,
      error: "1 number",
    },
    {
      id: hasDot,
      error: "cannot include a period",
    },
  ];

  useEffect(() => {
    setMinLength(value.length >= 8);
    setHasDot(!dot.test(value));
    setHasUpper(capitalLetter.test(value));
    setHasLower(smallLetter.test(value));
    setHasSpecial(specialChar.test(value));
    setHasNumber(number.test(value));
  }, [value]);

  return (
    <Box className="password-criteria-wrapper">
      <Box className="password-criteria">
        <Box sx={{ mb: 1, mt: 0 }} component="h4">
          Your password must have:{" "}
        </Box>
        {stateArray.map((e) => {
          return (
            <Box key={uuidv4()} sx={{ display: "flex", alignItems: "center" }}>
              {!e.id && <CircleIcon sx={{ fontSize: 13, color: red[500] }} />}
              {e.id && <CircleIcon sx={{ fontSize: 13, color: green[500] }} />}
              <Typography sx={{ pl: 1 }}>{e.error}</Typography>
            </Box>
          );
        })}
        <Box className="arrow"></Box>
      </Box>
    </Box>
  );
};

export default PasswordCritera;
